import { useState } from 'react'
import { Button, Toast, Uploader, Switch, Cell, Input } from 'react-vant'
import { ArrowLeft, Description, SmileO, Add } from '@react-vant/icons'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import request from '../../api/request'

export default function CreatePost() {
    const navigate = useNavigate()
    const { userInfo } = useSelector(state => state.user)
    const [loading, setLoading] = useState(false)
    const [attachments, setAttachments] = useState([])

    // 使用受控状态管理所有表单字段
    const [title, setTitle] = useState('')
    const [content, setContent] = useState('')
    const [category, setCategory] = useState('discussion')
    const [isOfficial, setIsOfficial] = useState(false)
    const [isPublic, setIsPublic] = useState(false)

    const categoryOptions = [
        { label: '讨论沙龙', value: 'discussion', emoji: '💬', color: '#056b4f', bg: '#f0fdf4' },
        { label: '互助问答', value: 'question', emoji: '🤔', color: '#d97706', bg: '#fff5f0' },
        { label: '共享文档', value: 'document', emoji: '📄', color: '#00b578', bg: '#f0f9f4' },
        { label: '校园通知', value: 'notice', emoji: '📢', color: '#e11d48', bg: '#fff0f2' },
    ]

    const handleSubmit = async () => {
        if (!title.trim()) {
            Toast.fail('请填写标题')
            return
        }
        if (!content.trim()) {
            Toast.fail('请填写正文')
            return
        }

        setLoading(true)
        try {
            const postData = {
                title: title.trim(),
                content: content.trim(),
                category: category,
                is_official: isOfficial,
                is_public: isPublic,
                is_pinned: false,
                attachments: (attachments || []).map(a => ({
                    file_name: a.file_name || 'file',
                    file_url: a.file_url || '',
                    file_type: a.file_type || 'file',
                    file_size: parseInt(a.file_size) || 0
                }))
            }
            await request.post('/hub/posts', postData)
            Toast.success({ message: '发布成功', icon: <SmileO /> })
            navigate('/hub', { replace: true })
        } catch (e) {
            console.error(e)
            Toast.fail(e.response?.data?.detail || '发布失败')
        } finally {
            setLoading(false)
        }
    }

    const uploadFile = async (file) => {
        const formData = new FormData()
        formData.append('file', file)
        try {
            const res = await request.post('/hub/upload', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
            setAttachments(prev => [...prev, res])
            return { url: res.file_url, status: 'done', message: '上传成功' }
        } catch (e) {
            Toast.fail('附件上传失败')
            return { status: 'failed', message: '上传失败' }
        }
    }

    const isTeacherOrAdmin = userInfo?.role === 'admin' || userInfo?.is_pe_teacher;

    return (
        <div style={{ background: '#f8fafc', minHeight: '100vh', paddingBottom: 100, fontFamily: '"Inter", "PingFang SC", "Microsoft YaHei", sans-serif' }}>
            {/* Header */}
            <div style={{ 
                background: 'rgba(255, 255, 255, 0.85)', 
                backdropFilter: 'blur(12px)',
                WebkitBackdropFilter: 'blur(12px)',
                padding: '12px 16px', 
                display: 'flex', 
                alignItems: 'center', 
                position: 'sticky', 
                top: 0, 
                zIndex: 100,
                borderBottom: '1px solid rgba(0,0,0,0.03)'
            }}>
                <div onClick={() => navigate(-1)} style={{ width: 36, height: 36, borderRadius: '50%', background: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: 12 }}>
                    <ArrowLeft size={20} color="#0f172a" />
                </div>
                <h3 style={{ margin: 0, fontSize: 18, fontWeight: 800, color: '#0f172a' }}>创作新内容</h3>
            </div>

            <div style={{ padding: '16px' }}>
                {/* 分类选择 */}
                <div style={{ marginBottom: 24 }}>
                    <div style={{ fontSize: 14, fontWeight: 700, color: '#0f172a', marginBottom: 12 }}>选择圈子</div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 12 }}>
                        {categoryOptions.map(opt => {
                            const isActive = category === opt.value
                            return (
                                <div
                                    key={opt.value}
                                    onClick={() => setCategory(opt.value)}
                                    style={{
                                        padding: '12px 16px',
                                        borderRadius: 16,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 8,
                                        cursor: 'pointer',
                                        background: isActive ? opt.bg : '#f8fafc',
                                        border: `1.5px solid ${isActive ? opt.color : 'transparent'}`,
                                        transition: 'all 0.2s',
                                        boxShadow: isActive ? `0 4px 12px ${opt.color}20` : 'none'
                                    }}
                                >
                                    <span style={{ fontSize: 20 }}>{opt.emoji}</span>
                                    <span style={{ fontSize: 14, fontWeight: isActive ? 700 : 500, color: isActive ? opt.color : '#475569' }}>{opt.label}</span>
                                </div>
                            )
                        })}
                    </div>
                </div>

                {/* 标题 */}
                <div style={{ marginBottom: 16 }}>
                    <div style={{ fontSize: 14, fontWeight: 700, color: '#0f172a', marginBottom: 8 }}>吸引人的标题</div>
                    <div style={{ background: '#f8fafc', borderRadius: 16, overflow: 'hidden', border: '1px solid #e2e8f0' }}>
                        <Input
                            value={title}
                            onChange={setTitle}
                            placeholder="给你的动态起个响亮的标题吧..."
                            clearable
                            style={{ padding: '12px 16px', fontSize: 16, fontWeight: 600 }}
                        />
                    </div>
                </div>

                {/* 正文 */}
                <div style={{ marginBottom: 16 }}>
                    <div style={{ fontSize: 14, fontWeight: 700, color: '#0f172a', marginBottom: 8 }}>详细内容</div>
                    <div style={{ background: '#f8fafc', borderRadius: 16, overflow: 'hidden', border: '1px solid #e2e8f0' }}>
                        <Input.TextArea
                            value={content}
                            onChange={setContent}
                            placeholder="分享你的见解、疑问或者是工作文档..."
                            rows={8}
                            autoSize={{ minHeight: 150 }}
                            showWordLimit
                            maxLength={5000}
                            style={{ padding: '12px 16px', fontSize: 15, lineHeight: 1.6 }}
                        />
                    </div>
                </div>

                {/* 发布权限控制 */}
                {isTeacherOrAdmin && (
                    <div style={{ background: '#fff', borderRadius: 16, marginBottom: 16, overflow: 'hidden', boxShadow: '0 2px 12px rgba(0,0,0,0.03)', border: '1px solid rgba(0,0,0,0.05)' }}>
                        {userInfo?.role === 'admin' && (
                            <Cell
                                title={<span style={{ fontWeight: 600 }}>官方发布</span>}
                                label="开启后带有官方红色标识"
                                rightIcon={
                                    <Switch
                                        size="22px"
                                        checked={isOfficial}
                                        onChange={setIsOfficial}
                                        activeColor="#e11d48"
                                    />
                                }
                                center
                            />
                        )}
                        <Cell
                            title={<span style={{ fontWeight: 600 }}>全校可见</span>}
                            label="开启后全校学生与家长均可查看"
                            rightIcon={
                                <Switch
                                    size="22px"
                                    checked={isPublic}
                                    onChange={setIsPublic}
                                    activeColor="#00b578"
                                />
                            }
                            center
                        />
                    </div>
                )}

                {/* 附件上传 */}
                <div>
                    <div style={{ fontSize: 14, fontWeight: 700, color: '#0f172a', marginBottom: 8, display: 'flex', justifyContent: 'space-between' }}>
                        <span>附加资源 <span style={{ color: '#94a3b8', fontWeight: 400 }}>(最多5个)</span></span>
                    </div>
                    <div style={{ background: '#fff', borderRadius: 16, padding: '16px', boxShadow: '0 2px 12px rgba(0,0,0,0.03)' }}>
                        <Uploader
                            upload={uploadFile}
                            accept="*"
                            maxCount={5}
                            onDelete={(file, detail) => {
                                setAttachments(prev => {
                                    const newAtts = [...prev]
                                    newAtts.splice(detail.index, 1)
                                    return newAtts
                                })
                            }}
                        >
                            <div style={{ width: 80, height: 80, background: '#f8fafc', border: '1px dashed #e2e8f0', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', borderRadius: 12, transition: 'all 0.2s' }}>
                                <Add size={24} color="#dcdee0" />
                                <span style={{ fontSize: 11, color: '#cbd5e1', marginTop: 8 }}>添加文件</span>
                            </div>
                        </Uploader>
                    </div>
                </div>
            </div>

            {/* 提交按钮悬浮栏 */}
            <div style={{ 
                position: 'fixed', bottom: 0, left: 0, right: 0, 
                padding: '16px 20px', 
                background: 'rgba(255, 255, 255, 0.9)', 
                backdropFilter: 'blur(10px)',
                WebkitBackdropFilter: 'blur(10px)',
                borderTop: '1px solid rgba(0,0,0,0.05)',
                boxShadow: '0 -4px 20px rgba(0,0,0,0.02)',
                zIndex: 100
            }}>
                <Button
                    color="linear-gradient(135deg, #055e43, #0c8c68)"
                    round
                    block
                    loading={loading}
                    onClick={handleSubmit}
                    style={{ height: 48, fontSize: 16, fontWeight: 700, boxShadow: '0 8px 16px rgba(5, 107, 79, 0.2)' }}
                >
                    立即发布
                </Button>
            </div>
        </div>
    )
}
